module.exports = __webpack_public_path__ + "static/media/IDO-BLANC.c671e734.png";